// extracted by mini-css-extract-plugin
export default {"page":"dZ-z","cartModal":"eZ-z","checkout":"fZ-z","placeholder":"gZ-z","account":"hZ-z"};